import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { Footer, requestPayload } from '../models/model';
import { ErrorhandlerService } from './errorhandler.service';
import { environment } from '../../../environments/environment';
import { apiUrl } from '../../config/api-url';
import { Router } from '@angular/router';
import config from '../../../assets/config.json';
@Injectable({
  providedIn: 'root',
})
export class FooterService {
  public complianceId: string = '';
  public defaultComplianceId: string = '';
  public disclosureText: string = '';
  public defaultDisclosureText: string = '';
  private readonly apiUrl = environment.apiHost; // Use HTTPS and secure URLs
  private readonly endPoints = apiUrl;
  constructor(
    private _http: HttpClient,
    private _errorHandlerService: ErrorhandlerService,
    private _router: Router,
  ) {}

  getFooterData(body: requestPayload): Observable<Footer> {
    const httpHeaderOptions: { headers: HttpHeaders } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': config.Ocp_Apim_Subscription_Key,
      }),
    };
    return this._http
      .post<Footer>(this.apiUrl + this.endPoints.getFooter, body, httpHeaderOptions)
      .pipe(catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)));
  }

  setComplianceID(id: string) {
    this.complianceId = id !== '' ? id : this.defaultComplianceId;
  }

  setDisclosureText(text: string) {
    this.disclosureText = text !== '' ? text : this.defaultDisclosureText;
  }
  getComplianceId() {
    const tokens = this._router.url.split('/');
    const currentComponent = tokens[tokens.length - 1];
    let compId = '';
    if (
      currentComponent === 'latest-rates' ||
      currentComponent === 'secure-file-upload' ||
      currentComponent === 'bypass-code' ||
      this._router.url.includes('/advisor/resources/') ||
      this._router.url.includes('/advisor/promos/') ||
      this._router.url.includes('/advisor/news/')
    ) {
      compId = this.complianceId;
    } else {
      compId = this.defaultComplianceId;
    }
    return compId;
  }

  getDisclosureText() {
    const tokens = this._router.url.split('/');
    const currentComponent = tokens[tokens.length - 1];
    let disclText = '';
    if (
      currentComponent === 'latest-rates' ||
      this._router.url.includes('/advisor/resources/') ||
      this._router.url.includes('/advisor/promos/') ||
      this._router.url.includes('/advisor/news/')
    ) {
      disclText = this.disclosureText;
    } else {
      disclText = this.defaultDisclosureText;
    }
    return disclText;
  }
}
